module.exports = __webpack_public_path__ + "static/media/mp3-player.aada6780.svg";